import { PageableRequest } from "@/types/PageableRequest";
import { httpClient } from "../client/httpClient";

class EducationService {
  fetchWorkerTrainingContents({
    query
  }: {
    query?: PageableRequest<{ ordering: string }>;
  }) {
    return httpClient.educations.worker_training_contents.$get({
      query
    });
  }
}

export const educationService = new EducationService();
